import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { Avatar, Box, Button, Card, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { api } from '../../utils/api'
import { getFromStorage } from '../../utils/storage'
import axios from 'axios'
import { handleError } from '../../utils/error'
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserActions, loadingActions } from '../../redux/store'
import Loading from '../../components/Loading'
import { mainGreen, mainRed } from '../../utils/color'

export default function AdminAccount() {
	const { isLoading } = useSelector((state) => state.isLoading)
	const dispatch = useDispatch()

	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [users, setUsers] = useState([])
	const getUsers = useCallback(
		async function () {
			dispatch(loadingActions.isLoading())
			try {
				const response = await axios({
					url: api.GET_ADMIN_ACCOUNT,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setUsers(response.data)
				dispatch(loadingActions.isLoaded())
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, dispatch, navigate],
	)

	useEffect(() => {
		getUsers()
	}, [getUsers])

	const deleteUser = async function (userId, storeManagerId, storeId) {
		try {
			const response = await axios({
				url: api.DELETE_USER_ADMIN,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { userId, storeManagerId, storeId },
				method: 'DELETE',
				withCredentials: true,
			})
			await getUsers()
			if (response.status === 200) {
				alert(response.data.message)
			}
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			{isLoading ? (
				<Loading />
			) : (
				<Box sx={{ maxWidth: 992, marginLeft: 'auto', marginRight: 'auto' }}>
					<Box
						sx={{
							marginTop: '10px',
							padding: '20px',
						}}>
						<Button
							size='medium'
							variant='contained'
							onClick={() => {
								navigate('/admin/signup-user')
							}}
							sx={{
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}>
							<PersonAddOutlinedIcon sx={{ mr: 1 }} /> Đăng ký người dùng
						</Button>
					</Box>
					{users?.map((user, index) => {
						return (
							<Card sx={{ margin: '10px 20px', padding: '10px' }} key={index}>
								<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
									<Box>
										<Typography sx={{ mb: 1 }}>Tên: {user.name}</Typography>
										<Typography sx={{ mb: 1 }}>Email: {user.email}</Typography>
										<Typography sx={{ mb: 1 }}>Vị trí: {user.role?.description}</Typography>
									</Box>
									<Avatar sx={{ width: 60, height: 60 }} alt='avatar' src={user.photo} />
								</Box>
								<Box display='flex' justifyContent='space-between' alignItems='flex-end'>
									<Button
										size='small'
										variant='contained'
										sx={{
											background: mainGreen,
											'&:hover': { background: mainGreen },
										}}
										onClick={() => {
											navigate(`/admin/edit-user/${user.id}`)
										}}>
										Thay đổi vị trí
									</Button>
									<Button
										sx={{
											marginLeft: 'auto',
											p: 0,
											background: mainRed,
											'&:hover': { background: mainRed },
										}}
										size='small'
										variant='contained'
										onClick={() => {
											const confirmDelete = window.confirm('Bạn có chắc muốn xóa người dùng này?')
											if (confirmDelete) {
												deleteUser(user.id, user.store?.storeManager._id, user.store._id)
											}
										}}>
										Xóa
									</Button>
								</Box>
							</Card>
						)
					})}
				</Box>
			)}
		</UserLayout>
	)
}
